import { render } from "./LicenseProof.vue?vue&type=template&id=626ca355&scoped=true"
import script from "./LicenseProof.vue?vue&type=script&lang=js"
export * from "./LicenseProof.vue?vue&type=script&lang=js"

import "./LicenseProof.vue?vue&type=style&index=0&id=626ca355&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626ca355"]])

export default __exports__